import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

// Helper
import { Helper } from '../helpers/helper';
@Injectable()
export class CuadreService {

  constructor(private http: HttpClient, private helper: Helper) { }

    // Registrar prestamo
    registrarAperturaDia(data: any) {
      return this.http.post(`${this.helper.urlServer}/api/v1/aperturar-dia`, data,
        {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    obtenerAperturas(limit?, offset?, rutas?, empleado?, fecha_desde?, fecha_hasta?, orders?, estado?) {
      let params = new HttpParams();
      if (estado) {
        params = params.append('estado', estado);
      }
      if (limit && !isNaN(limit)) {
        params = params.append('limit', limit);
        params = params.append('offset', offset);
      }
      if (rutas) {
        params = params.append('rutas', rutas);
      }
      if (fecha_desde) {
        params = params.append('fecha_inicia', fecha_desde);
      }
      if (fecha_hasta) {
        params = params.append('fecha_termina', fecha_hasta);
      }
      if (empleado) {
        params = params.append('empleado', empleado);
      }
      if (orders) {
        params = params.append('orders', orders);
      }
      return this.http.get( `${this.helper.urlServer}/api/v1/lista-apertura-dia`,
      { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
    }

    anadirCapital(data: any) {
      return this.http.post(`${this.helper.urlServer}/api/v1/anadir-capital-apertura-dia`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    obtenerGastosDietas(ruta = '0', fecha = '') {
      let params = new HttpParams();
      params = params.append('ruta', ruta);
      params = params.append('fecha', fecha);
      return this.http.get(`${this.helper.urlServer}/api/v1/tablero-gastos-dietas`,
      {headers: this.helper.getHeader(localStorage.getItem('token')), params});
    }

    listaGastosDietas(rutas?, limit?, offset?, fecha_desde?, fecha_hasta?, empleado?, orders?) {
      let params = new HttpParams();
      if (rutas) {
        params = params.append('rutas', rutas);
      }
      if (limit) {
        params = params.append('limit', limit);
        params = params.append('offset', offset);
      }
      if (fecha_desde) {
        params = params.append('fecha_inicia', fecha_desde);
      }
      if (fecha_hasta) {
        params = params.append('fecha_termina', fecha_hasta);
      }
      if (empleado) {
        params = params.append('empleado', empleado);
      }
      if (orders) {
        params = params.append('orders', orders);
      }
      return this.http.get(`${this.helper.urlServer}/api/v1/lista-gastos-dietas`,
      {headers: this.helper.getHeader(localStorage.getItem('token')), params});
    }

    obtenerGastoporID(id: number) {
      return this.http.get(`${this.helper.urlServer}/api/v1/obtener-gasto/${id}`,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    obtenerCierrePorApertura(ID_APERTURA) {
      return this.http.get(`${this.helper.urlServer}/api/v1/cierre-dia/${ID_APERTURA}`,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    cambiarAperturaEstado(data: any) {
      return this.http.put(`${ this.helper.urlServer }/api/v1/cambiar-apertura-dia-estado`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    actualizarCierreMontoCapitalIngresado(data: any) {
      return this.http.put(`${ this.helper.urlServer }/api/v1/actualizar-cierre-monto-capital`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    cerrarDia(data: any) {
      return this.http.put(`${this.helper.urlServer}/api/v1/cerrar-dia-desktop`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    obtenerCuadre(ID_APERTURA) {
      return this.http.get(`${this.helper.urlServer}/api/v1/cuadre-cierre/${ID_APERTURA}`,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    registrarGastos(data: any) {
      return this.http.post(`${this.helper.urlServer}/api/v1/registrar-gastos-desktop`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
    }

    actualizarGastos(data: any) {
      // console.log(data);

      const datos = {
                        ID_GASTO: data.ID_GASTO,
                        ID_RUTA: data.ID_RUTA,
                        ID_EMPLEADO: data.ID_EMPLEADO,
                        tipo_gasto: data.tipo_gasto,
                        capital: data.capital,
                        descripcion: data.descripcion || '',
                        fecha_registro: data.fecha_registro.year + '-' + data.fecha_registro.month + '-' + data.fecha_registro.day,
                        fecha_modificacion: new Date(this.helper.getDate()),
                        modificado_por: data.modificado_por
                      };
      return this.http.put(`${this.helper.urlServer}/api/v1/actualizar-gastos-desktop`, datos,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});

    }

  reporteGastos(fecha_desde?, fecha_hasta?, limit?, offset?, rutas?, orders?) {
    let params = new HttpParams();
    if (fecha_desde && fecha_hasta) {
      params = params.append('fecha_inicia', fecha_desde);
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      console.log(rutas)
      params = params.append('rutas', rutas);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-lista-gastos-dietas`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerCuadresConDiferencia(limit?, offset?, rutas?, busqueda?, fecha_desde?, fecha_hasta?, orders?) {
    let params = new HttpParams();
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/cuadres-con-faltante`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerRecorrido(ID_APERTURA) {

    return this.http.get(`${this.helper.urlServer}/api/v1/recorrido/${ID_APERTURA}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerApertura(ID_APERTURA) {
    return this.http.get(`${this.helper.urlServer}/api/v1/apertura/${ID_APERTURA}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  editarApertura(data: any) {
    return this.http.put(`${ this.helper.urlServer }/api/v1/editar-apertura-dia`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarCapitalAnadido(ID: any) {
    return this.http.delete(`${ this.helper.urlServer }/api/v1/eliminar-capital-anadido-apertura/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarGasto(ID: any) {
    return this.http.delete(`${ this.helper.urlServer }/api/v1/eliminar-gasto/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  reabrirApertura(ID_APERTURA) {
    return this.http.put(`${ this.helper.urlServer }/api/v1/reabrir-apertura`, { ID_APERTURA } ,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarApertura(ID: any) {
    return this.http.delete(`${ this.helper.urlServer }/api/v1/eliminar-apertura/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  registrarSalidaEfectivo(data: any) {
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-salida-efectivo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarSalidaEfectivo(ID: any) {
    return this.http.delete(`${ this.helper.urlServer }/api/v1/eliminar-salida-efectivo-apertura/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  cobradoresTrabajando(limit?, offset?, rutas?, busqueda?) {
    let params = new HttpParams();
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    return this.http.get<{ data: any[], total_items: number }>( `${this.helper.urlServer}/api/v1/cobradores-trabajando`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/cuadre.service.ts